import React from 'react';
export function ProductIntro() {
  const features = ['12 tomos organizados por nivel y materia', '180 ejercicios con secuencia completa', '6 bonus estratégicos de gestión', 'Todo listo para usar desde hoy'];
  return <section className="bg-gray-100 py-12 md:py-16 px-4" data-id="element-198">
      <div className="max-w-4xl mx-auto text-center" data-id="element-199">
        <div className="text-sci-orange text-xs uppercase tracking-wide mb-4 font-semibold" data-id="element-200">
          LA SOLUCIÓN
        </div>

        <div className="text-carbon font-bold text-2xl md:text-3xl mb-2 tracking-wide" data-id="element-201">
          CIENCIAS 360
        </div>

        <p className="text-gray-700 text-base md:text-lg mb-10" data-id="element-202">
          El sistema N°1 para docentes de Física y Química
          <br data-id="element-203" />
          en Argentina secundaria
        </p>

        {/* Features */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-10" data-id="element-204">
          {features.map((feature, i) => <div key={i} className="bg-white p-4 rounded-lg shadow-sm" data-id="element-205">
              <p className="text-sm md:text-base text-gray-700" data-id="element-206">{feature}</p>
            </div>)}
        </div>

        {/* Level Badges */}
        <div className="flex flex-col md:flex-row gap-6 justify-center items-center" data-id="element-207">
          <div className="flex gap-2 items-center" data-id="element-208">
            <div className="flex gap-2" data-id="element-209">
              <span className="bg-carbon text-white px-3 py-1 rounded text-sm font-semibold" data-id="element-210">
                2do FQ
              </span>
              <span className="bg-carbon text-white px-3 py-1 rounded text-sm font-semibold" data-id="element-211">
                3ro FQ
              </span>
            </div>
            <span className="text-sm text-gray-600" data-id="element-212">← FÍSICO-QUÍMICA</span>
          </div>

          <div className="flex gap-2 items-center" data-id="element-213">
            <div className="flex gap-2 flex-wrap justify-center" data-id="element-214">
              <span className="bg-carbon text-white px-3 py-1 rounded text-sm font-semibold" data-id="element-215">
                4to FÍS
              </span>
              <span className="bg-carbon text-white px-3 py-1 rounded text-sm font-semibold" data-id="element-216">
                5to FÍS
              </span>
              <span className="bg-carbon text-white px-3 py-1 rounded text-sm font-semibold" data-id="element-217">
                4to QUÍM
              </span>
              <span className="bg-carbon text-white px-3 py-1 rounded text-sm font-semibold" data-id="element-218">
                5to QUÍM
              </span>
            </div>
            <span className="text-sm text-gray-600" data-id="element-219">← FÍSICA Y QUÍMICA</span>
          </div>
        </div>
      </div>
    </section>;
}